import apiClient from './apiClient';

interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

export interface CommentUser {
  _id: string;
  name?: string;
  username?: string;
  profileImage?: string;
  email?: string;
}

export interface CommentPostRef {
  _id: string;
  caption?: string;
}

export interface Comment {
  _id: string;
  user?: CommentUser | string;
  post?: CommentPostRef | string;
  text: string;
  likesCount?: number;
  parentComment?: string | null;
  createdAt: string;
}

export interface CommentsPagination {
  currentPage: number;
  totalPages: number;
  totalItems?: number;
  itemsPerPage?: number;
}

class CommentsService {
  /** Admin: list ALL comments. Backend: GET /comments/admin/all. */
  async getAllComments(params: { page?: number; limit?: number } = {}) {
    const response = await apiClient.get<ApiResponse<{ comments: Comment[]; pagination: CommentsPagination }>>(
      '/comments/admin/all',
      { params },
    );
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to fetch comments');
    }
    const data: any = response.data.data;
    return {
      comments: (data?.comments ?? []) as Comment[],
      pagination: (data?.pagination ?? { currentPage: 1, totalPages: 1 }) as CommentsPagination,
    };
  }

  /** Delete any comment (admin-allowed). Backend: DELETE /comments/:id. */
  async deleteComment(id: string) {
    const response = await apiClient.delete<ApiResponse<null>>(`/comments/${id}`);
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to delete comment');
    }
    return true;
  }
}

const commentsService = new CommentsService();
export default commentsService;
